import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Wordmark, CherrySwirl, CameraIcon } from "@/components/Brand";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("cerenza_token")) navigate("/admin", { replace: true });
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("cerenza_token", data.token);
      localStorage.setItem("cerenza_email", data.email);
      toast.success("¡Bienvenida!");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Error al iniciar sesión.");
    } finally {
      setLoading(false);
    }
  };

  const fieldClass = "mt-2 w-full bg-cerenza-cream/60 border border-cerenza-pink rounded-2xl px-4 h-12 text-base focus:outline-none focus:ring-2 focus:ring-cerenza-cherry focus:border-cerenza-cherry";

  return (
    <main className="min-h-screen bg-cerenza-cream flex flex-col relative overflow-hidden" data-testid="admin-login-page">
      <CherrySwirl color="#cd2e2e" className="absolute top-24 right-[8%] w-16 h-16 opacity-30 animate-float" />
      <CherrySwirl color="#cd2e2e" className="absolute bottom-24 left-[6%] w-12 h-12 opacity-30 animate-float" />

      <header className="px-6 md:px-12 py-6 flex items-center justify-between">
        <Link to="/" data-testid="admin-login-logo"><Wordmark className="h-9 md:h-10" /></Link>
        <p className="eyebrow flex items-center gap-2"><CameraIcon color="#cd2e2e" className="w-4 h-4" /> Acceso estudio</p>
      </header>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-2 gap-12 px-6 md:px-12 py-10 md:py-16">
        <div className="hidden lg:flex relative items-end">
          <div className="absolute -inset-2 bg-cerenza-pink rounded-[120px_60px_120px_60px] -z-0" aria-hidden="true" />
          <div className="relative z-10 overflow-hidden rounded-[80px_24px_80px_24px] w-full h-[480px]">
            <img
              src="https://images.unsplash.com/photo-1581952976147-5a2d15560349?q=85&w=1200&auto=format&fit=crop"
              alt="Familia"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="flex items-center justify-center">
          <form onSubmit={onSubmit} className="w-full max-w-md" data-testid="admin-login-form">
            <p className="eyebrow">— Panel del estudio —</p>
            <h1 className="font-display text-5xl md:text-6xl mt-3 text-cerenza-cherry leading-[1.02]">
              Bienvenida de vuelta.
            </h1>
            <p className="mt-4 text-cerenza-ink/65">Accede a tus reservas y experiencias.</p>

            <div className="mt-10 space-y-6">
              <div>
                <label className="eyebrow text-cerenza-ink/70">Email</label>
                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className={fieldClass} />
              </div>
              <div>
                <label className="eyebrow text-cerenza-ink/70">Contraseña</label>
                <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className={fieldClass} />
              </div>
            </div>

            <button type="submit" disabled={loading} data-testid="login-submit" className="btn-cherry mt-10 w-full justify-center disabled:opacity-60">
              {loading ? "Accediendo…" : "Acceder al panel →"}
            </button>

            <Link to="/" className="block mt-6 text-xs uppercase tracking-[0.18em] font-semibold text-cerenza-cherry hover:opacity-70 transition-opacity" data-testid="admin-back-home">
              ← Volver al sitio
            </Link>
          </form>
        </div>
      </div>
    </main>
  );
}
